<template>
  <div class="main-content-container container-fluid px-4">
    <!-- Page Header -->
    <div class="page-header row no-gutters py-4">
      <div class="col-12 col-sm-4 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle">Dashboard</span>
        <h3 class="page-title">Pending Approval</h3>
      </div>
    </div>

    <p align="right">
      <d-col lg="3">
        <div class="category py-2">
          <div>
            <div>
              Date: <span>{{ date.toISOString().substr(0,10).replace() }}</span>
            </div>
            <d-datepicker
              v-model="date"
              @input="onDateRangeChange"
              @opened="handleOpened"
              @closed="handleClosed"
              typeable
            />
          </div>
        </div>
      </d-col>
    </p>
    <!-- Default Light Table -->
    <div class="row">
      <div class="col">
        <div class="card card-small mb-4">
          <div class="card-header border-bottom">
            <h6 class="m-0">Booking</h6>
          </div>
          <div class="card-body p-0 pb-3 text-center">
            <table class="table mb-0">
              <thead class="bg-light">
                <tr>
                  <th scope="col" class="border-0">Booking ID</th>
                  <th scope="col" class="border-0">Date</th>
                  <th scope="col" class="border-0">Start Time</th>
                  <th scope="col" class="border-0">End Time</th>
                  <th scope="col" class="border-0">Number of Children</th>
                  <th scope="col" class="border-0"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="result in results" :key="result.bookingId">
                  <td>{{ result.bookingId }}</td>
                  <td>{{ result.date }}</td>
                  <td>{{ result.startTime }}</td>
                  <td>{{ result.endTime }}</td>
                  <td>{{ result.noOfChildrens }}</td>
                  <td>
                    <d-button-group size="small">
                      <d-button
                        class="btn-white"
                        @click="handleClick('approve', result.bookingId)"
                      >
                        <span class="text-success"
                          ><i class="material-icons">check</i></span
                        >
                        Approve
                      </d-button>
                      <d-button
                        class="btn-white"
                        @click="handleClick('reject', result.bookingId)"
                      >
                        <span class="text-danger"
                          ><i class="material-icons">clear</i></span
                        >
                        Reject
                      </d-button>
                      <d-button
                        class="btn-white"
                        @click="selectRow(result.bookingId)"
                      >
                        <span class="text-light">
                          <i class="material-icons">more_vert</i></span>
                        Details
                      </d-button>
                    </d-button-group>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      results: [],
      opened: false,
      date: new Date(),
    };
  },
  methods: {
    selectRow(bookingId){
      if (bookingId != null) {
        this.$router.push({
          name: "booking-details",
          params: { id: bookingId},
        });
      }
    },
    handleOpened() {
      this.opened = true;
    },
    handleClosed() {
      this.opened = false;
    },
    async handleClick(approvalStatus, bookingID) {
      alert(approvalStatus + bookingID);
      await axios.put(
        process.env.VUE_APP_API+"api/staff/Booking/" +
          bookingID + "/approve",
        {
          approvalStatus: approvalStatus,
        }
      );
      this.loadPage();
    },
    async onDateRangeChange() {
      await axios
        .get(
          process.env.VUE_APP_API+"api/staff/Booking?approvalStatus=Pending&date=" +
            this.date.toISOString()
        )
        .then((response) => {
          this.results = response.data.result;
          console.log(response.data.result);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    async loadPage() {
      await axios
        .get(
          process.env.VUE_APP_API+"api/staff/Booking?approvalstatus=Pending"
        )
        .then((response) => {
          this.results = response.data.result;
        })
        .catch(function (error) {
        });
    },
  },
  mounted: function () {
    this.loadPage();
  },
};
</script>